// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   MenuItem,
//   Select,
//   TablePagination,
//   CircularProgress,
//   Alert,
//   TextField,
//   Snackbar,
//   FormGroup,
//   FormControlLabel,
//   Checkbox,
//   Autocomplete,
// } from "@mui/material";
// import AdminSidebar from "../../AdminSidebar";
// import { fetchUsers, fetchRoles, fetchPermissions } from "../../api";
// import { useAuth } from "../../App";
// import { hasPermission } from "../../utils/permissions";
// import Forbidden403 from "../../components/common/Forbidden403";
// import Chip from "@mui/material/Chip";
// import IconButton from "@mui/material/IconButton";
// import Tooltip from "@mui/material/Tooltip";
// import SearchIcon from "@mui/icons-material/Search";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import LockResetIcon from "@mui/icons-material/LockReset";
// import InputAdornment from "@mui/material/InputAdornment";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import DialogContentText from "@mui/material/DialogContentText";
// import CloseIcon from "@mui/icons-material/Close";
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

// function ResetPasswordModal({ open, onClose, onConfirm, user, loading, error }) {
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
//       <DialogTitle>Reset Password for {user?.email}</DialogTitle>
//       <DialogContent sx={{ minWidth: 320 }}>
//         <DialogContentText>
//           This will generate a new random password for <b>{user?.email}</b> and email it to them. Are you sure you want to proceed?
//         </DialogContentText>
//         {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} disabled={loading}>Cancel</Button>
//         <Button onClick={onConfirm} variant="contained" color="secondary" disabled={loading}>
//           {loading ? "Resetting..." : "Reset & Send Email"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// function UserDetailsModal({ open, onClose, user }) {
//   if (!user) return null;

//   // is_active color
//   let activeColor = user.is_active ? "success" : "default";

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//         User Details
//         <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
//       </DialogTitle>
//       <DialogContent>
//         <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
//           <Typography variant="h6">{user.full_name}</Typography>
//           <Typography component="span" variant="body2" color="text.secondary">({user.email})</Typography>
//           <Chip label={user.is_active ? "Active" : "Inactive"} color={activeColor} size="small" sx={{ ml: 1 }} />
//           <Chip label={user.is_recruiter ? "Recruiter" : "Not Recruiter"} color={user.is_recruiter ? "primary" : "default"} size="small" sx={{ ml: 1 }} />
//         </Box>
//         <Box sx={{ mb: 2 }}>
//           <Typography variant="subtitle1">Roles</Typography>
//           {user.roles && user.roles.length > 0 ? user.roles.map(role => (
//             <Chip key={role.id} label={role.name} sx={{ mr: 1, mb: 1 }} />
//           )) : <Typography variant="body2" color="text.secondary">-</Typography>}
//         </Box>
//         <Box sx={{ mb: 2 }}>
//           <Typography variant="subtitle1">Extra Permissions</Typography>
//           {user.extra_permissions && user.extra_permissions.length > 0 ? (
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
//               {user.extra_permissions.map(perm => (
//                 <Chip key={perm} label={perm} color="secondary" size="small" />
//               ))}
//             </Box>
//           ) : <Typography variant="body2" color="text.secondary">-</Typography>}
//         </Box>
//         <Box>
//           <Typography variant="subtitle1">User ID</Typography>
//           <Typography variant="body2" color="text.secondary">{user.id}</Typography>
//         </Box>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} variant="contained">Close</Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// function UserTable({ users, onEdit, onDelete, onResetPassword, loading, search, setSearch, onRowClick }) {
//   // Filter users by search
//   const filteredUsers = users.filter(u => {
//     const q = search.trim().toLowerCase();
//     return (
//       !q ||
//       (u.email && u.email.toLowerCase().includes(q)) ||
//       (u.full_name && u.full_name.toLowerCase().includes(q))
//     );
//   });

//   if (loading) return <CircularProgress sx={{ mt: 4, mb: 2 }} />;

//   return (
//     <>
//       <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//         <TextField
//           placeholder="Search users..."
//           value={search}
//           onChange={e => setSearch(e.target.value)}
//           size="small"
//           sx={{ width: 300, mr: 2 }}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon />
//               </InputAdornment>
//             ),
//           }}
//         />
//       </Box>
//       <Table size="small">
//         <TableHead>
//           <TableRow>
//             <TableCell>Email</TableCell>
//             <TableCell>Full Name</TableCell>
//             <TableCell>Roles</TableCell>
//             <TableCell>Extra Permissions</TableCell>
//             <TableCell>Actions</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {filteredUsers.map((user) => (
//             <TableRow
//               key={user.id}
//               hover
//               sx={{
//                 cursor: "pointer",
//                 transition: "transform 0.13s cubic-bezier(.4,2,.6,1), box-shadow 0.13s cubic-bezier(.4,2,.6,1)",
//                 '&:hover': {
//                   transform: "scale(1.012)",
//                   boxShadow: 3,
//                   backgroundColor: "#f5faff"
//                 }
//               }}
//               onClick={e => {
//                 // Only trigger onRowClick if not clicking in the actions cell
//                 if (e.target.closest('[data-action-cell]')) return;
//                 onRowClick(user);
//               }}
//             >
//               <TableCell>{user.email}</TableCell>
//               <TableCell>
//                 <span style={{ color: user.is_active === false ? '#d32f2f' : undefined }}>
//                   {user.full_name}
//                 </span>
//               </TableCell>
//               <TableCell>
//                 {user.roles && user.roles.length > 0
//                   ? user.roles.map((r) => r.name).join(", ")
//                   : "-"}
//               </TableCell>
//               <TableCell>
//                 {user.extra_permissions && user.extra_permissions.length > 0
//                   ? user.extra_permissions.map((permission) => (
//                       <Chip key={permission} label={permission} sx={{ mr: 1 }} />
//                     ))
//                   : "-"}
//               </TableCell>
//               <TableCell data-action-cell>
//                 <Tooltip title="Edit">
//                   <IconButton color="primary" onClick={e => { e.stopPropagation(); onEdit(user); }} size="small">
//                     <EditIcon />
//                   </IconButton>
//                 </Tooltip>
//                 <Tooltip title={user.is_active ? 'Deactivate User' : 'Reactivate User'}>
//                   <IconButton 
//                     onClick={e => { e.stopPropagation(); onDelete(user); }} 
//                     size="small"
//                     sx={{
//                       color: user.is_active ? 'error.main' : 'text.disabled',
//                       '&:hover': {
//                         backgroundColor: 'action.hover'
//                       }
//                     }}
//                   >
//                     <DeleteOutlineIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//                 <Tooltip title="Reset Password">
//                   <IconButton color="secondary" onClick={e => { e.stopPropagation(); onResetPassword(user); }} size="small">
//                     <LockResetIcon />
//                   </IconButton>
//                 </Tooltip>
//               </TableCell>
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </>
//   );
// }

// function UserModal({ open, onClose, user, roles, onSave }) {
//   const { fetchWithAuth } = useAuth();
//   const isEdit = !!user;
//   const [form, setForm] = useState({
//     email: "",
//     full_name: "",
//     password: "",
//     password2: "",
//     role_ids: [], // Always initialize as array
//     is_active: true,
//     is_recruiter: false,
//     is_superuser: false,
//     is_applicant: true,
//     extra_permissions: [], // List of permission keys/strings
//   });
//   const [errors, setErrors] = useState({});
//   const [allPermissions, setAllPermissions] = useState([]);
//   const [permissionsLoading, setPermissionsLoading] = useState(false);
//   const [permissionsError, setPermissionsError] = useState(null);

//   useEffect(() => {
//     // Fetch all permissions for multi-select
//     setPermissionsLoading(true);
//     setPermissionsError(null);
//     if (fetchWithAuth) {
//       fetchPermissions(fetchWithAuth)
//         .then((perms) => setAllPermissions(perms))
//         .catch((e) =>
//           setPermissionsError(e.message || "Failed to fetch permissions")
//         )
//         .finally(() => setPermissionsLoading(false));
//     }
//   }, [fetchWithAuth]);

//   useEffect(() => {
//     if (user) {
//       // Defensive: support user.role_ids, user.roles (array of objects), or user.role_id
//       let roleIds = [];
//       if (Array.isArray(user.role_ids)) {
//         roleIds = user.role_ids;
//       } else if (Array.isArray(user.roles)) {
//         roleIds = user.roles.map((r) => (typeof r === "object" ? r.id : r));
//       } else if (user.role_id) {
//         roleIds = [user.role_id];
//       }
//       setForm({
//         email: user.email || "",
//         full_name: user.full_name || "",
//         password: "",
//         password2: "",
//         role_ids: roleIds,
//         is_active: user.is_active !== undefined ? user.is_active : true,
//         is_recruiter: !!user.is_recruiter,
//         is_superuser: !!user.is_superuser,
//         is_applicant: user.is_applicant !== undefined ? user.is_applicant : true,
//         extra_permissions: Array.isArray(user.extra_permissions)
//           ? user.extra_permissions
//           : user.permissions || [],
//       });
//     } else {
//       setForm({
//         email: "",
//         full_name: "",
//         password: "",
//         password2: "",
//         role_ids: [],
//         is_active: true,
//         is_recruiter: false,
//         is_superuser: false,
//         is_applicant: true,
//         extra_permissions: [],
//       });
//     }
//     setErrors({});
//   }, [user, open]);

//   const validate = () => {
//     const e = {};
//     if (!form.email && !isEdit) e.email = "Email is required";
//     if (!form.full_name) e.full_name = "Full name is required";
//     if (!form.role_ids || form.role_ids.length === 0)
//       e.role_ids = "Role is required";
//     if (!isEdit && !form.password) e.password = "Password is required";
//     if (!isEdit && form.password !== form.password2)
//       e.password2 = "Passwords do not match";
//     if (!isEdit && form.is_applicant === false && form.email && !/(@averdex)\.[a-z]+$/i.test(form.email)) {
//       e.email = "Non-applicant users must have @averdex email domain";
//     }
//     return e;
//   };

//   const handleChange = (field) => (e) => {
//     const value =
//       e.target.type === "checkbox" ? e.target.checked : e.target.value;
//     setForm((f) => ({ ...f, [field]: value }));
//   };

//   const handleSave = () => {
//     const e = validate();
//     setErrors(e);
//     if (Object.keys(e).length === 0) {
//       // Always send full user object with role_ids as array
//       const out = {
//         email: form.email,
//         full_name: form.full_name,
//         is_active: !!form.is_active,
//         role_ids: form.role_ids,
//         extra_permissions: form.extra_permissions,
//         is_recruiter: !!form.is_recruiter,
//         is_superuser: !!form.is_superuser,
//         is_applicant: !!form.is_applicant,
//       };
//       if (!isEdit && form.password) out.password = form.password;
//       // Only send password if present (for create)
//       onSave(out);
//     }
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>{isEdit ? "Edit User" : "Create User"}</DialogTitle>
//       <DialogContent sx={{ minWidth: 400 }}>
//         <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
//           <TextField
//             label="Email"
//             value={form.email}
//             onChange={handleChange("email")}
//             fullWidth
//             required
//             disabled={isEdit}
//             error={!!errors.email}
//             helperText={errors.email}
//           />
//           <TextField
//             label="Full Name"
//             value={form.full_name}
//             onChange={handleChange("full_name")}
//             fullWidth
//             required
//             error={!!errors.full_name}
//             helperText={errors.full_name}
//           />
//           {!isEdit && (
//             <>
//               <TextField
//                 label="Password"
//                 type="password"
//                 value={form.password}
//                 onChange={handleChange("password")}
//                 fullWidth
//                 required
//                 error={!!errors.password}
//                 helperText={errors.password}
//               />
//               <TextField
//                 label="Confirm Password"
//                 type="password"
//                 value={form.password2}
//                 onChange={handleChange("password2")}
//                 fullWidth
//                 required
//                 error={!!errors.password2}
//                 helperText={errors.password2}
//               />
//             </>
//           )}
//           <Box>
//             <Typography variant="subtitle1" sx={{ mb: 1 }}>
//               Roles
//             </Typography>
//             <FormGroup row>
//               {roles.map((role) => (
//                 <FormControlLabel
//                   key={role.id}
//                   control={
//                     <Checkbox
//                       checked={form.role_ids.includes(role.id)}
//                       onChange={(e) => {
//                         setForm((f) => {
//                           const checked = e.target.checked;
//                           const id = role.id;
//                           let next;
//                           if (checked) {
//                             next = [...f.role_ids, id];
//                           } else {
//                             next = f.role_ids.filter((rid) => rid !== id);
//                           }
//                           return { ...f, role_ids: next };
//                         });
//                       }}
//                       name={role.name}
//                     />
//                   }
//                   label={role.name}
//                 />
//               ))}
//             </FormGroup>
//             {errors.role_ids && (
//               <Typography color="error" variant="caption">
//                 {errors.role_ids}
//               </Typography>
//             )}
//           </Box>

//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={Boolean(form.is_active)}
//                 onChange={(e) =>
//                   setForm((f) => ({ ...f, is_active: e.target.checked }))
//                 }
//               />
//             }
//             label="Active"
//             sx={{ mb: 2 }}
//           />

//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={!!form.is_applicant}
//                 onChange={handleChange("is_applicant")}
//                 name="is_applicant"
//               />
//             }
//             label="Is Applicant"
//           />

//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={!!form.is_recruiter}
//                 onChange={handleChange("is_recruiter")}
//                 name="is_recruiter"
//               />
//             }
//             label="Is Recruiter"
//           />

//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={!!form.is_superuser}
//                 onChange={handleChange("is_superuser")}
//                 name="is_superuser"
//               />
//             }
//             label="Is Superuser"
//           />

//           {isEdit && (
//             <Box sx={{ mt: 2 }}>
//               <Typography variant="subtitle1" sx={{ mb: 1 }}>
//                 Extra Permissions
//               </Typography>
//               {permissionsLoading ? (
//                 <Typography variant="body2">Loading permissions...</Typography>
//               ) : permissionsError ? (
//                 <Typography color="error">{permissionsError}</Typography>
//               ) : (
//                 <Autocomplete
//                   multiple
//                   options={allPermissions}
//                   disableCloseOnSelect
//                   getOptionLabel={(option) => option}
//                   value={form.extra_permissions}
//                   onChange={(_, value) =>
//                     setForm((f) => ({ ...f, extra_permissions: value }))
//                   }
//                   renderOption={(props, option, { selected }) => (
//                     <li {...props}>
//                       <Checkbox style={{ marginRight: 8 }} checked={selected} />
//                       {option}
//                     </li>
//                   )}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       variant="outlined"
//                       label="Search & Select Permissions"
//                       placeholder="Type to search..."
//                     />
//                   )}
//                   sx={{ minWidth: 320, maxWidth: 500 }}
//                 />
//               )}
//             </Box>
//           )}
//         </Box>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose}>Cancel</Button>
//         <Button onClick={handleSave} variant="contained">
//           Save
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// function ConfirmationModal({ open, onClose, onConfirm, user, action }) {
//   if (!user) return null;
  
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
//       <DialogTitle>{action === 'deactivate' ? 'Deactivate User' : 'Reactivate User'}</DialogTitle>
//       <DialogContent>
//         <DialogContentText>
//           {action === 'deactivate' 
//             ? `Are you sure you want to deactivate ${user.email}? They will not be able to log in.`
//             : `Are you sure you want to reactivate ${user.email}? They will be able to log in again.`
//           }
//         </DialogContentText>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose}>Cancel</Button>
//         <Button 
//           onClick={onConfirm} 
//           color={action === 'deactivate' ? 'error' : 'primary'}
//           variant="contained"
//         >
//           {action === 'deactivate' ? 'Deactivate' : 'Reactivate'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// export default function UsersPage() {
//   const { auth, fetchWithAuth } = useAuth();
//   const API_URL = process.env.REACT_APP_API_URL;
//   const hasListPermission = hasPermission(auth?.user, "user.list") && hasPermission(auth?.user, "role.list");
//   if (!hasListPermission) {
//     return (
//       <Box sx={{ display: 'flex', minHeight: '100vh', background: '#f7f7fa' }}>
//         <AdminSidebar selected="Users" />
//         <Box sx={{ flex: 1, p: 3, mt: 7, mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Forbidden403 message="Failed to fetch users: You are not authorized to perform this action. Please contact your system administrator." />
//         </Box>
//       </Box>
//     );
//   }
//   const [search, setSearch] = useState("");
//   const [resetModalOpen, setResetModalOpen] = useState(false);
//   const [resetUser, setResetUser] = useState(null);
//   const [resetLoading, setResetLoading] = useState(false);
//   const [resetError, setResetError] = useState("");
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [detailsUser, setDetailsUser] = useState(null);

//   const [users, setUsers] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [success, setSuccess] = useState(null);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   // Pagination state
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [userToDeactivate, setUserToDeactivate] = useState(null);
//   const [confirmOpen, setConfirmOpen] = useState(false);
  

//   // Load users and roles
//   const loadData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       let usersResp, rolesResp;
//       try {
//         usersResp = await fetchUsers(fetchWithAuth);
//       } catch (e) {
//         if (e && e.message && e.message.includes("403")) {
//           setError(
//             "You do not have permission to view users. Please contact your administrator."
//           );
//         } else {
//           setError(
//             "Failed to fetch users: " +
//               (e.message.includes("JSON")
//                 ? "API returned non-JSON (possible backend error or not running)"
//                 : e.message)
//           );
//         }
//         setLoading(false);
//         return;
//       }
//       try {
//         rolesResp = await fetchRoles(fetchWithAuth);
//       } catch (e) {
//         setError(
//           "Failed to fetch roles: " +
//             (e.message.includes("JSON")
//               ? "API returned non-JSON (possible backend error or not running)"
//               : e.message)
//         );
//         setLoading(false);
//         return;
//       }
//       setUsers(usersResp);
//       setRoles(rolesResp);
//       setLoading(false);
//     } catch (err) {
//       setError(err.message || "Failed to load data");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadData();
//     // eslint-disable-next-line
//   }, [fetchWithAuth]);

//   const handleEdit = (user) => {
//     setSelectedUser(user);
//     setModalOpen(true);
//   };
//   const handleCreate = () => {
//     setSelectedUser(null);
//     setModalOpen(true);
//   };
//   const handleDelete = (user) => {
//     setUserToDeactivate(user);
//     setConfirmOpen(true);
//   };

//   const confirmDelete = async () => {
//     if (!userToDeactivate) return;
    
//     const action = userToDeactivate.is_active ? 'deactivate' : 'reactivate';
//     try {
//       setLoading(true);
      
//       // Update user's active status
//       const apiUrl = `${API_URL}/users/${userToDeactivate.id}`;
//       const response = await fetchWithAuth(apiUrl, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           is_active: !userToDeactivate.is_active,
//           // Include other required fields
//           email: userToDeactivate.email,
//           full_name: userToDeactivate.full_name || '',
//           is_superuser: userToDeactivate.is_superuser || false,
//           is_recruiter: userToDeactivate.is_recruiter || false,
//           is_applicant: userToDeactivate.is_applicant !== false, // Default to true if not set
//           role_ids: userToDeactivate.roles ? userToDeactivate.roles.map(r => r.id) : [],
//           extra_permissions: userToDeactivate.extra_permissions || []
//         })
//       });
      
//       if (!response.ok) {
//         let errorMessage = `Failed to ${action} user`;
//         try {
//           const errorData = await response.json();
//           errorMessage = errorData.detail || errorMessage;
//         } catch (e) {
//           console.error('Error parsing error response:', e);
//         }
//         throw new Error(errorMessage);
//       }
      
//       const responseData = await response.json();
      
//       // Update the local state immediately for better UX
//       setUsers(prevUsers => {
//         const updatedUsers = prevUsers.map(u => 
//           u.id === userToDeactivate.id 
//             ? { 
//                 ...u, 
//                 is_active: responseData.is_active,
//                 // Make sure to include any other fields that might be in the response
//                 ...responseData
//               } 
//             : u
//         );
//         return updatedUsers;
//       });
      
//       setSuccess(`User ${action}d successfully`);
//       setSnackbarOpen(true);
      
//       // Still refresh the data to ensure consistency
//       await loadData();
//     } catch (e) {
//       console.error(`Error ${action}ing user:`, e);
//       setError(e.message || `Failed to ${action} user`);
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//       setConfirmOpen(false);
//       setUserToDeactivate(null);
//     }
//   };
//   const handleResetPassword = (user) => {
//     setResetUser(user);
//     setResetError("");
//     setResetModalOpen(true);
//   };
//   const handleResetPasswordConfirm = async () => {
//     try {
//       setResetLoading(true);
//       await import("../../api").then(({ resetUserPassword }) =>
//         resetUserPassword(fetchWithAuth, resetUser.id)
//       );
//       setSuccess("Password reset and email sent successfully");
//       setSnackbarOpen(true);
//       setResetModalOpen(false);
//     } catch (e) {
//       setResetError(e.message || "Failed to reset password and send email");
//     } finally {
//       setResetLoading(false);
//     }
//   };
//   const handleSave = async (form) => {
//     try {
//       setLoading(true);
//       setError(null);
//       if (selectedUser) {
//         // Edit user: always send full object, including email and role_ids as array
//         await import("../../api").then(({ updateUser }) =>
//           updateUser(fetchWithAuth, selectedUser.id, form)
//         );
//         setSuccess("User updated successfully");
//       } else {
//         // Create user: send full object, including role_ids as array
//         await import("../../api").then(({ createUser }) =>
//           createUser(fetchWithAuth, form)
//         );
//         setSuccess("User created successfully");
//       }
//       setSnackbarOpen(true);
//       setModalOpen(false);
//       await loadData();
//     } catch (e) {
//       setError(e.message || "Failed to save user");
//     } finally {
//       setLoading(false);
//     }
//   };
//   // Handle delete confirmation
//   const handleDeleteConfirm = async () => {
//     if (userToDeactivate) {
//       await confirmDelete();
//     }
//   };

//   // Pagination handlers
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Paginate users client-side for now
//   const paginatedUsers = users.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   return (
//     <Box sx={{ display: "flex", minHeight: "100vh", background: "#f7f7fa" }}>
//       <AdminSidebar selected="Users" />
//       <Box sx={{ flex: 1, p: 3, mt: 7, mb: 3 }}>
//         <Paper elevation={2} sx={{ p: 3, mb: 2 }}>
//           <Typography variant="h4" gutterBottom>
//             Users Management
//           </Typography>
//           {error && (
//             <Alert
//               severity={error.includes("permission") ? "warning" : "error"}
//               sx={{ mb: 2 }}
//             >
//               {error}
//             </Alert>
//           )}
//           <Button
//             variant="contained"
//             sx={{ mb: 2 }}
//             onClick={handleCreate}
//             disabled={loading || (error && error.includes("permission"))}
//           >
//             Invite User
//           </Button>
//           <UserTable
//             users={paginatedUsers}
//             onEdit={handleEdit}
//             onDelete={handleDelete}
//             onResetPassword={handleResetPassword}
//             loading={loading}
//             search={search}
//             setSearch={setSearch}
//             onRowClick={(user) => setDetailsUser(user)}
//           />
//           <TablePagination
//             component="div"
//             count={users.length}
//             page={page}
//             onPageChange={handleChangePage}
//             rowsPerPage={rowsPerPage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//             rowsPerPageOptions={[5, 10, 25, 50]}
//             sx={{ mt: 2 }}
//           />
//           <UserModal
//             open={modalOpen}
//             onClose={() => setModalOpen(false)}
//             user={selectedUser}
//             roles={roles}
//             onSave={handleSave}
//             loading={loading}
//           />
//           <UserDetailsModal
//             open={!!detailsUser}
//             onClose={() => setDetailsUser(null)}
//             user={detailsUser}
//           />
//           <ResetPasswordModal
//             open={resetModalOpen}
//             onClose={() => setResetModalOpen(false)}
//             onConfirm={handleResetPasswordConfirm}
//             user={resetUser}
//             loading={resetLoading}
//             error={resetError}
//           />
//           <Snackbar
//             open={snackbarOpen}
//             autoHideDuration={3000}
//             onClose={() => setSnackbarOpen(false)}
//             anchorOrigin={{ vertical: "top", horizontal: "center" }}
//             message={success}
//           />
//         </Paper>
//       </Box>
      
//       {/* Confirmation Dialog */}
//       <ConfirmationModal
//         open={confirmOpen}
//         onClose={() => setConfirmOpen(false)}
//         onConfirm={handleDeleteConfirm}
//         user={userToDeactivate}
//         action={userToDeactivate?.is_active ? 'deactivate' : 'reactivate'}
//       />
//     </Box>
//   );
// }


import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
  CircularProgress,
  Alert,
  TextField,
  Snackbar,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Autocomplete,
  Chip,
  IconButton,
  Tooltip,
  InputAdornment,
  DialogContentText,
  Toolbar,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import AdminSidebar from "../../AdminSidebar";
import { fetchUsers, fetchRoles, fetchPermissions } from "../../api";
import { useAuth } from "../../App";
import { hasPermission } from "../../utils/permissions";
import Forbidden403 from "../../components/common/Forbidden403";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import LockResetIcon from "@mui/icons-material/LockReset";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

function ResetPasswordModal({ open, onClose, onConfirm, user, loading, error }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const text = dark ? "#e8f0fe" : "#0f0f1a";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 800,
          color: text,
          letterSpacing: "-0.02em",
        }}
      >
        Reset Password for {user?.email}
      </DialogTitle>

      <DialogContent dividers sx={{ minWidth: 320 }}>
        <DialogContentText>
          This will generate a new random password for <b>{user?.email}</b> and
          email it to them. Are you sure you want to proceed?
        </DialogContentText>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="secondary" disabled={loading}>
          {loading ? "Resetting..." : "Reset & Send Email"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function UserDetailsModal({ open, onClose, user }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";

  if (!user) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: 800,
          color: text,
          letterSpacing: "-0.02em",
        }}
      >
        User Details
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 800, color: text }}>
            {user.full_name}
          </Typography>
          <Typography component="span" variant="body2" color="text.secondary">
            ({user.email})
          </Typography>
          <Chip
            label={user.is_active ? "Active" : "Inactive"}
            color={user.is_active ? "success" : "default"}
            size="small"
            sx={{ ml: 1 }}
          />
          <Chip
            label={user.is_recruiter ? "Recruiter" : "Not Recruiter"}
            color={user.is_recruiter ? "primary" : "default"}
            size="small"
            sx={{ ml: 1 }}
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ color: text, mb: 1 }}>
            Roles
          </Typography>
          {user.roles && user.roles.length > 0 ? (
            user.roles.map((role) => <Chip key={role.id} label={role.name} sx={{ mr: 1, mb: 1 }} />)
          ) : (
            <Typography variant="body2" sx={{ color: mid }}>
              -
            </Typography>
          )}
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ color: text, mb: 1 }}>
            Extra Permissions
          </Typography>
          {user.extra_permissions && user.extra_permissions.length > 0 ? (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
              {user.extra_permissions.map((perm) => (
                <Chip key={perm} label={perm} color="secondary" size="small" />
              ))}
            </Box>
          ) : (
            <Typography variant="body2" sx={{ color: mid }}>
              -
            </Typography>
          )}
        </Box>

        <Box>
          <Typography variant="subtitle1" sx={{ color: text }}>
            User ID
          </Typography>
          <Typography variant="body2" sx={{ color: mid }}>
            {user.id}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function UserTable({
  users,
  onEdit,
  onDelete,
  onResetPassword,
  loading,
  search,
  setSearch,
  onRowClick,
}) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const filteredUsers = users.filter((u) => {
    const q = search.trim().toLowerCase();
    return (
      !q ||
      (u.email && u.email.toLowerCase().includes(q)) ||
      (u.full_name && u.full_name.toLowerCase().includes(q))
    );
  });

  if (loading) {
    return <CircularProgress sx={{ mt: 4, mb: 2 }} />;
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <TextField
          placeholder="Search users..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          size="small"
          sx={{
            width: { xs: "100%", sm: 320 },
            "& .MuiOutlinedInput-root": {
              borderRadius: "14px",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: muted, fontSize: 18 }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <TableContainer
        sx={{
          borderRadius: "18px",
          border: `1px solid ${border}`,
          overflowX: "auto",
        }}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              {["Email", "Full Name", "Roles", "Extra Permissions", "Actions"].map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    fontWeight: 700,
                    color: mid,
                    background: dark ? "#111827" : "#fafafa",
                    borderBottom: `1px solid ${border}`,
                    whiteSpace: "nowrap",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredUsers.map((user) => (
              <TableRow
                key={user.id}
                hover
                sx={{
                  cursor: "pointer",
                  "& td": {
                    borderBottom: `1px solid ${border}`,
                    background: dark ? "rgba(13,18,32,0.96)" : "#ffffff",
                    color: mid,
                  },
                  "&:hover td": {
                    background: dark ? "rgba(255,255,255,0.03)" : "rgba(15,15,26,0.02)",
                  },
                }}
                onClick={(e) => {
                  if (e.target.closest("[data-action-cell]")) return;
                  onRowClick(user);
                }}
              >
                <TableCell>{user.email}</TableCell>

                <TableCell>
                  <span style={{ color: user.is_active === false ? "#d32f2f" : text }}>
                    {user.full_name}
                  </span>
                </TableCell>

                <TableCell>
                  {user.roles && user.roles.length > 0
                    ? user.roles.map((r) => r.name).join(", ")
                    : "-"}
                </TableCell>

                <TableCell>
                  {user.extra_permissions && user.extra_permissions.length > 0 ? (
                    user.extra_permissions.map((permission) => (
                      <Chip key={permission} label={permission} sx={{ mr: 1, mb: 0.5 }} />
                    ))
                  ) : (
                    "-"
                  )}
                </TableCell>

                <TableCell data-action-cell sx={{ whiteSpace: "nowrap" }}>
                  <Tooltip title="Edit">
                    <IconButton
                      color="primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        onEdit(user);
                      }}
                      size="small"
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title={user.is_active ? "Deactivate User" : "Reactivate User"}>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(user);
                      }}
                      size="small"
                      sx={{
                        color: user.is_active ? "error.main" : "text.disabled",
                        "&:hover": {
                          backgroundColor: "action.hover",
                        },
                      }}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Reset Password">
                    <IconButton
                      color="secondary"
                      onClick={(e) => {
                        e.stopPropagation();
                        onResetPassword(user);
                      }}
                      size="small"
                    >
                      <LockResetIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}

            {filteredUsers.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography sx={{ py: 3, color: muted }}>
                    No users found.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

function UserModal({ open, onClose, user, roles, onSave }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const text = dark ? "#e8f0fe" : "#0f0f1a";

  const { fetchWithAuth } = useAuth();
  const isEdit = !!user;
  const [form, setForm] = useState({
    email: "",
    full_name: "",
    password: "",
    password2: "",
    role_ids: [],
    is_active: true,
    is_recruiter: false,
    is_superuser: false,
    is_applicant: true,
    extra_permissions: [],
  });
  const [errors, setErrors] = useState({});
  const [allPermissions, setAllPermissions] = useState([]);
  const [permissionsLoading, setPermissionsLoading] = useState(false);
  const [permissionsError, setPermissionsError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setPermissionsLoading(true);
    setPermissionsError(null);
    if (fetchWithAuth) {
      fetchPermissions(fetchWithAuth)
        .then((perms) => setAllPermissions(perms))
        .catch((e) => setPermissionsError(e.message || "Failed to fetch permissions"))
        .finally(() => setPermissionsLoading(false));
    }
  }, [fetchWithAuth]);

  useEffect(() => {
    if (user) {
      let roleIds = [];
      if (Array.isArray(user.role_ids)) {
        roleIds = user.role_ids;
      } else if (Array.isArray(user.roles)) {
        roleIds = user.roles.map((r) => (typeof r === "object" ? r.id : r));
      } else if (user.role_id) {
        roleIds = [user.role_id];
      }

      setForm({
        email: user.email || "",
        full_name: user.full_name || "",
        password: "",
        password2: "",
        role_ids: roleIds,
        is_active: user.is_active !== undefined ? user.is_active : true,
        is_recruiter: !!user.is_recruiter,
        is_superuser: !!user.is_superuser,
        is_applicant: user.is_applicant !== undefined ? user.is_applicant : true,
        extra_permissions: Array.isArray(user.extra_permissions)
          ? user.extra_permissions
          : user.permissions || [],
      });
    } else {
      setForm({
        email: "",
        full_name: "",
        password: "",
        password2: "",
        role_ids: [],
        is_active: true,
        is_recruiter: false,
        is_superuser: false,
        is_applicant: true,
        extra_permissions: [],
      });
    }
    setErrors({});
  }, [user, open]);

  const validate = () => {
    const e = {};
    if (!form.email && !isEdit) e.email = "Email is required";
    if (!form.full_name) e.full_name = "Full name is required";
    if (!form.role_ids || form.role_ids.length === 0) e.role_ids = "Role is required";
    if (!isEdit && !form.password) e.password = "Password is required";
    if (!isEdit && form.password !== form.password2) e.password2 = "Passwords do not match";
    if (
      !isEdit &&
      form.is_applicant === false &&
      form.email &&
      !/(@averdex)\.[a-z]+$/i.test(form.email)
    ) {
      e.email = "Non-applicant users must have @averdex email domain";
    }
    return e;
  };

  const handleChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm((f) => ({ ...f, [field]: value }));
  };

  const handleSave = () => {
    const e = validate();
    setErrors(e);
    if (Object.keys(e).length === 0) {
      const out = {
        email: form.email,
        full_name: form.full_name,
        is_active: !!form.is_active,
        role_ids: form.role_ids,
        extra_permissions: form.extra_permissions,
        is_recruiter: !!form.is_recruiter,
        is_superuser: !!form.is_superuser,
        is_applicant: !!form.is_applicant,
      };
      if (!isEdit && form.password) out.password = form.password;
      onSave(out);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 800,
          color: text,
          letterSpacing: "-0.02em",
        }}
      >
        {isEdit ? "Edit User" : "Create User"}
      </DialogTitle>

      <DialogContent dividers sx={{ minWidth: 400 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            label="Email"
            value={form.email}
            onChange={handleChange("email")}
            fullWidth
            required
            disabled={isEdit}
            error={!!errors.email}
            helperText={errors.email}
          />

          <TextField
            label="Full Name"
            value={form.full_name}
            onChange={handleChange("full_name")}
            fullWidth
            required
            error={!!errors.full_name}
            helperText={errors.full_name}
          />

          {!isEdit && (
            <>
              <TextField
                label="Password"
                type={showPassword ? "text" : "password"}
                value={form.password}
                onChange={handleChange("password")}
                fullWidth
                required
                error={!!errors.password}
                helperText={errors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword((s) => !s)} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                label="Confirm Password"
                type={showPassword ? "text" : "password"}
                value={form.password2}
                onChange={handleChange("password2")}
                fullWidth
                required
                error={!!errors.password2}
                helperText={errors.password2}
              />
            </>
          )}

          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1, color: text }}>
              Roles
            </Typography>
            <FormGroup row>
              {roles.map((role) => (
                <FormControlLabel
                  key={role.id}
                  control={
                    <Checkbox
                      checked={form.role_ids.includes(role.id)}
                      onChange={(e) => {
                        setForm((f) => {
                          const checked = e.target.checked;
                          const roleId = role.id;
                          let next;
                          if (checked) {
                            next = [...f.role_ids, roleId];
                          } else {
                            next = f.role_ids.filter((rid) => rid !== roleId);
                          }
                          return { ...f, role_ids: next };
                        });
                      }}
                      name={role.name}
                    />
                  }
                  label={role.name}
                />
              ))}
            </FormGroup>
            {errors.role_ids && (
              <Typography color="error" variant="caption">
                {errors.role_ids}
              </Typography>
            )}
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(form.is_active)}
                onChange={(e) => setForm((f) => ({ ...f, is_active: e.target.checked }))}
              />
            }
            label="Active"
            sx={{ mb: 1 }}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={!!form.is_applicant}
                onChange={handleChange("is_applicant")}
                name="is_applicant"
              />
            }
            label="Is Applicant"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={!!form.is_recruiter}
                onChange={handleChange("is_recruiter")}
                name="is_recruiter"
              />
            }
            label="Is Recruiter"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={!!form.is_superuser}
                onChange={handleChange("is_superuser")}
                name="is_superuser"
              />
            }
            label="Is Superuser"
          />

          {isEdit && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1, color: text }}>
                Extra Permissions
              </Typography>

              {permissionsLoading ? (
                <Typography variant="body2">Loading permissions...</Typography>
              ) : permissionsError ? (
                <Typography color="error">{permissionsError}</Typography>
              ) : (
                <Autocomplete
                  multiple
                  options={allPermissions}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  value={form.extra_permissions}
                  onChange={(_, value) =>
                    setForm((f) => ({ ...f, extra_permissions: value }))
                  }
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox style={{ marginRight: 8 }} checked={selected} />
                      {option}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Search & Select Permissions"
                      placeholder="Type to search..."
                    />
                  )}
                  sx={{ minWidth: 320, maxWidth: 500 }}
                />
              )}
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function ConfirmationModal({ open, onClose, onConfirm, user, action }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const text = dark ? "#e8f0fe" : "#0f0f1a";

  if (!user) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 800,
          color: text,
          letterSpacing: "-0.02em",
        }}
      >
        {action === "deactivate" ? "Deactivate User" : "Reactivate User"}
      </DialogTitle>

      <DialogContent dividers>
        <DialogContentText>
          {action === "deactivate"
            ? `Are you sure you want to deactivate ${user.email}? They will not be able to log in.`
            : `Are you sure you want to reactivate ${user.email}? They will be able to log in again.`}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onConfirm}
          color={action === "deactivate" ? "error" : "primary"}
          variant="contained"
        >
          {action === "deactivate" ? "Deactivate" : "Reactivate"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default function UsersPage() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const panelBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const { auth, fetchWithAuth } = useAuth();
  const API_URL = process.env.REACT_APP_API_URL;
  const hasListPermission =
    hasPermission(auth?.user, "user.list") && hasPermission(auth?.user, "role.list");

  const [search, setSearch] = useState("");
  const [resetModalOpen, setResetModalOpen] = useState(false);
  const [resetUser, setResetUser] = useState(null);
  const [resetLoading, setResetLoading] = useState(false);
  const [resetError, setResetError] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [detailsUser, setDetailsUser] = useState(null);

  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [success, setSuccess] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [userToDeactivate, setUserToDeactivate] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  if (!hasListPermission) {
    return (
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
        <AdminSidebar selected="Users" />
        <Box
          sx={{
            flex: 1,
            p: 3,
            mt: 7,
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Forbidden403 message="Failed to fetch users: You are not authorized to perform this action. Please contact your system administrator." />
        </Box>
      </Box>
    );
  }

  const loadData = async () => {
    setLoading(true);
    setError(null);
    try {
      let usersResp, rolesResp;
      try {
        usersResp = await fetchUsers(fetchWithAuth);
      } catch (e) {
        if (e && e.message && e.message.includes("403")) {
          setError("You do not have permission to view users. Please contact your administrator.");
        } else {
          setError(
            "Failed to fetch users: " +
              (e.message.includes("JSON")
                ? "API returned non-JSON (possible backend error or not running)"
                : e.message)
          );
        }
        setLoading(false);
        return;
      }

      try {
        rolesResp = await fetchRoles(fetchWithAuth);
      } catch (e) {
        setError(
          "Failed to fetch roles: " +
            (e.message.includes("JSON")
              ? "API returned non-JSON (possible backend error or not running)"
              : e.message)
        );
        setLoading(false);
        return;
      }

      setUsers(usersResp);
      setRoles(rolesResp);
      setLoading(false);
    } catch (err) {
      setError(err.message || "Failed to load data");
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [fetchWithAuth]);

  const handleEdit = (user) => {
    setSelectedUser(user);
    setModalOpen(true);
  };

  const handleCreate = () => {
    setSelectedUser(null);
    setModalOpen(true);
  };

  const handleDelete = (user) => {
    setUserToDeactivate(user);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!userToDeactivate) return;

    const action = userToDeactivate.is_active ? "deactivate" : "reactivate";
    try {
      setLoading(true);

      const apiUrl = `${API_URL}/users/${userToDeactivate.id}`;
      const response = await fetchWithAuth(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          is_active: !userToDeactivate.is_active,
          email: userToDeactivate.email,
          full_name: userToDeactivate.full_name || "",
          is_superuser: userToDeactivate.is_superuser || false,
          is_recruiter: userToDeactivate.is_recruiter || false,
          is_applicant: userToDeactivate.is_applicant !== false,
          role_ids: userToDeactivate.roles ? userToDeactivate.roles.map((r) => r.id) : [],
          extra_permissions: userToDeactivate.extra_permissions || [],
        }),
      });

      if (!response.ok) {
        let errorMessage = `Failed to ${action} user`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.detail || errorMessage;
        } catch (e) {
          console.error("Error parsing error response:", e);
        }
        throw new Error(errorMessage);
      }

      const responseData = await response.json();

      setUsers((prevUsers) => {
        const updatedUsers = prevUsers.map((u) =>
          u.id === userToDeactivate.id
            ? {
                ...u,
                is_active: responseData.is_active,
                ...responseData,
              }
            : u
        );
        return updatedUsers;
      });

      setSuccess(`User ${action}d successfully`);
      setSnackbarOpen(true);
      await loadData();
    } catch (e) {
      console.error(`Error ${action}ing user:`, e);
      setError(e.message || `Failed to ${action} user`);
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
      setConfirmOpen(false);
      setUserToDeactivate(null);
    }
  };

  const handleResetPassword = (user) => {
    setResetUser(user);
    setResetError("");
    setResetModalOpen(true);
  };

  const handleResetPasswordConfirm = async () => {
    try {
      setResetLoading(true);
      await import("../../api").then(({ resetUserPassword }) =>
        resetUserPassword(fetchWithAuth, resetUser.id)
      );
      setSuccess("Password reset and email sent successfully");
      setSnackbarOpen(true);
      setResetModalOpen(false);
    } catch (e) {
      setResetError(e.message || "Failed to reset password and send email");
    } finally {
      setResetLoading(false);
    }
  };

  const handleSave = async (form) => {
    try {
      setLoading(true);
      setError(null);
      if (selectedUser) {
        await import("../../api").then(({ updateUser }) =>
          updateUser(fetchWithAuth, selectedUser.id, form)
        );
        setSuccess("User updated successfully");
      } else {
        await import("../../api").then(({ createUser }) =>
          createUser(fetchWithAuth, form)
        );
        setSuccess("User created successfully");
      }
      setSnackbarOpen(true);
      setModalOpen(false);
      await loadData();
    } catch (e) {
      setError(e.message || "Failed to save user");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteConfirm = async () => {
    if (userToDeactivate) {
      await confirmDelete();
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedUsers = users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
      <AdminSidebar selected="Users" />

      <Box
        sx={{
          flex: 1,
          pl: { xs: 1.5, md: 3 },
          pr: { xs: 1.5, md: 3 },
          pt: 2,
          pb: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />

        <Container maxWidth="xl" disableGutters sx={{ mt: 1 }}>
          <Box
            sx={{
              mb: 3,
              overflow: "hidden",
              borderRadius: "28px",
              border: `1px solid ${border}`,
              background: dark
                ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
                : `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
              boxShadow: dark
                ? "0 32px 80px rgba(0,0,0,0.30)"
                : "0 32px 80px rgba(15,15,26,0.08)",
            }}
          >
            <Box
              sx={{
                p: { xs: 3, sm: 4, md: 5 },
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Box>
                <SectionEyebrow color={accent}>AjiraHQ · Users</SectionEyebrow>
                <Typography
                  sx={{
                    mt: 2,
                    color: text,
                    fontWeight: 800,
                    fontSize: "clamp(30px, 4vw, 44px)",
                    lineHeight: 1.06,
                    letterSpacing: "-0.03em",
                    mb: 0.75,
                  }}
                >
                  Manage users and access.
                </Typography>
                <Typography
                  sx={{
                    color: mid,
                    fontSize: "15px",
                    lineHeight: 1.8,
                    maxWidth: 620,
                  }}
                >
                  Invite users, manage roles and permissions, reset passwords, and
                  control account status.
                </Typography>
              </Box>

              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 700,
                  borderRadius: "12px",
                  px: 2.5,
                  py: 1.1,
                  background: accent,
                  boxShadow: `0 14px 34px ${alpha(accent, 0.22)}`,
                  "&:hover": {
                    background: accent,
                    filter: "brightness(1.08)",
                  },
                }}
                onClick={handleCreate}
                disabled={loading || (error && error.includes("permission"))}
              >
                Invite User
              </Button>
            </Box>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: "22px",
              background: panelBg,
              border: `1px solid ${border}`,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.20)"
                : "0 12px 30px rgba(15,23,42,0.06)",
            }}
          >
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: "1.25rem",
                color: text,
                mb: 2,
                letterSpacing: "-0.02em",
              }}
            >
              Users Management
            </Typography>

            {error && (
              <Alert
                severity={error.includes("permission") ? "warning" : "error"}
                sx={{ mb: 2, borderRadius: "18px" }}
              >
                {error}
              </Alert>
            )}

            {loading ? (
              <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
                <CircularProgress size={40} sx={{ color: accent }} />
              </Box>
            ) : (
              <>
                <UserTable
                  users={paginatedUsers}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                  onResetPassword={handleResetPassword}
                  loading={loading}
                  search={search}
                  setSearch={setSearch}
                  onRowClick={(user) => setDetailsUser(user)}
                />

                <TablePagination
                  component="div"
                  count={users.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  sx={{ mt: 2, color: mid }}
                />
              </>
            )}

            <UserModal
              open={modalOpen}
              onClose={() => setModalOpen(false)}
              user={selectedUser}
              roles={roles}
              onSave={handleSave}
            />

            <UserDetailsModal
              open={!!detailsUser}
              onClose={() => setDetailsUser(null)}
              user={detailsUser}
            />

            <ResetPasswordModal
              open={resetModalOpen}
              onClose={() => setResetModalOpen(false)}
              onConfirm={handleResetPasswordConfirm}
              user={resetUser}
              loading={resetLoading}
              error={resetError}
            />

            <Snackbar
              open={snackbarOpen}
              autoHideDuration={3000}
              onClose={() => setSnackbarOpen(false)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert severity="success" onClose={() => setSnackbarOpen(false)}>
                {success}
              </Alert>
            </Snackbar>
          </Paper>
        </Container>
      </Box>

      <ConfirmationModal
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleDeleteConfirm}
        user={userToDeactivate}
        action={userToDeactivate?.is_active ? "deactivate" : "reactivate"}
      />
    </Box>
  );
}